import SolicitacaoStore from './SolicitacaoStore'

class SolicitacaoStoreMiddleware {
  solicitacaoStore: SolicitacaoStore
}

// eslint-disable-next-line import/prefer-default-export
export const solicitacaoStoreMiddleware = new SolicitacaoStoreMiddleware()
